/*@flow*/
const getScreenWidth = (): {|
  lg: boolean,
  lt: {|lg: boolean, md: boolean, sm: boolean, xs: boolean|},
  md: boolean,
  sm: boolean,
  xs: boolean,
|} => ({
  xs: window.innerWidth < 768,
  sm: window.innerWidth > 768 && window.innerWidth < 1024,
  md: window.innerWidth > 1024 && window.innerWidth < 1440,
  lg: window.innerWidth > 1440,

  // Less than...
  lt: {
    xs: window.innerWidth < 495,
    sm: window.innerWidth < 768,
    md: window.innerWidth < 1024,
    lg: window.innerWidth > 1024,
  },
});

export default getScreenWidth;
export const isMediumScreen = (): boolean => window.innerWidth < 1440;
export const isSmallScreen = (): boolean => getScreenWidth().lt.md;
export const isXSmallScreen = (): boolean => getScreenWidth().lt.sm;
export const isLargeScreen = (): boolean => window.innerWidth > 1024;
